<template>
    <VideoPageNotFound :logged-in="authStore.loggedIn" />
</template>

<script setup>
import { useAuthStore } from '~/store/auth';

const authStore = useAuthStore();
</script>
